import Extension from "../base/extension";

class AOSInit extends Extension {
  name = "AOSInit";

  #started = false;

  async init() {
    // If the page has no AOS usage, do nothing
    const hasAos = document.querySelector("[data-aos]");
    if (!hasAos) return;

    const AOS = await window.Stencil.ensureVendor("aos");

    if (!this.#started) {
      AOS.init({ once: true });
      this.#started = true;
      // console.log(this.logPrefix, "AOS initialised");
      return;
    }

    // If init() is called again later (optional), refresh instead of re-init
    AOS.refreshHard();
  }
}

export default AOSInit;